import type { Locale } from '../types/locales'
import { LocaleCode } from '../types/locales'

const locales: Array<Locale> = [
  {
    code: LocaleCode.SL,
    file: 'sl.json',
    iso: 'sl-SI',
    name: 'Slovenščina'
  },
  {
    code: LocaleCode.EN,
    file: 'en.json',
    iso: 'en-US',
    name: 'English'
  },
  {
    code: LocaleCode.ES,
    file: 'es.json',
    iso: 'es-ES',
    name: 'Spanish'
  },
  {
    code: LocaleCode.DE,
    file: 'de.json',
    iso: 'de-DE',
    name: 'Deutsch'
  }
]

export default locales
